import '../../themeDefaults';

export default ({ datepickerReact }) => ({
  timepicker: {
    '& select': {
      '&:focus': {
        outlineColor: datepickerReact.focusColor,
      },
    },
    float: 'right',
  },
  timepickerLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '16px',
    marginTop: 4,
    ...datepickerReact.timepickerLabel,
  },
});
